// Course payment flags (stripeEnabled / qrPaymentEnabled) default ON when never saved — mirrors
// backend utils/paymentAccess.ts isFlagOn. Older rows may carry the string 'false'.
export function isFlagOn(value: unknown): boolean {
  return value !== false && value !== 'false';
}
